// TODO: Yes, fix the shit out of this.
import moment from 'moment-timezone'

// Returns date formatted as 'YYYY-MM-DD'.
Date.prototype.format = function() {
  const m = this.getMonth() + 1
  const d = this.getDate()

  return [
    this.getFullYear(),
    m.toString().padStart(2,'0'),
    d.toString().padStart(2,'0'),
  ].join('-')
}

Date.prototype.dayName = function() {
  return this.toLocaleDateString(undefined, {weekday: 'long'})
}

// Returns date of the Monday and Sunday of:
// () -> the current week
// (date) -> the week that date falls in
export function getWeek(date) {
  const d = (typeof date === 'object') ? date : new Date()
  const startDate = new Date(d)
  startDate.setDate(d.getDate() - d.getDay())
  const endDate = new Date(d)
  endDate.setDate(d.getDate() - d.getDay() + 7)

  return {
    start: startDate.format(),
    end: endDate.format(),
  }
}

// Returns user's zone (string).
export function getZone() {
  return moment.tz.guess()
}

// Returns date for X days ago.
// () -> from today
// (date) -> from the specified date
export function getXDaysAgo(x, date) {
  const d = (typeof date === 'object') ? date : new Date()
  const startDate = new Date(d)
  startDate.setDate(d.getDate() - x)
  return {
    start: startDate.format(),
    end: d.format(),
  }
}

// Returns date for 7 days ago.
// () -> from today
// (date) -> from the specified date
export function get7DaysAgo(date) {
  const d = (typeof date === 'object') ? date : new Date()
  const startDate = new Date(d)
  startDate.setDate(d.getDate() - 7 + 1)
  return {
    start: startDate.format(),
    end: d.format(),
  }
}

export function time24To12(t) {
  if (!t) {
    return null
  } else {
    return moment(t, 'HH:mm').format('hh:mm A')
  }
}

export function time12To24(t) {
  if (!t) {
    return null
  } else {
    return moment(t, 'hh:mm A').format('HH:mm')
  }
}

export function roundUp15Minutes(t, military = false) {
  const format = military ? 'HH:mm' : 'hh:mm A'
  const start = moment(t, format)
  const remainder = 15 - (start.minute() % 15)
  const finish = moment(start)
    .add(remainder, 'minutes')
    .format(format)
  return finish
}

export function formatDuration(t) {
  const hours = Math.floor(t) ? Math.floor(t) + 'h ' : ''
  const mins = Math.round((t % 1) * 60) ? Math.round((t % 1) * 60) + 'm' : ''
  return hours + mins ? hours + mins : '0'
}

// Takes a time in the format 'hh:mm A'.
// Takes duration as a number in minutes.
// Returns a time in the format 'hh:mm A'.
export function subtractDurationFromTime(time, duration, military = false) {
  const format = military ? 'HH:mm' : 'hh:mm A'
  return moment(time, format)
    .subtract(moment.duration(duration, 'minutes'))
    .format(format)
}

export function addDurationToTime(time, duration, military = false) {
  const format = military ? 'HH:mm' : 'hh:mm A'
  return moment(time, format)
    .add(moment.duration(duration, 'minutes'))
    .format(format)
}

export function dateArray(dateFrom, dateTo) {
  const result = []
  let from = moment(dateFrom, 'YYYY-MM-DD')
  let to = moment(dateTo, 'YYYY-MM-DD').add(1, 'd')
  while (from.format('YYYY-MM-DD') !== to.format('YYYY-MM-DD')) {
    result.push({
      day: from.format('dd').split('')[0],
      date: from.format('YYYY-MM-DD')
    })
    from.add(1, 'd')
  }
  return result
}

export function isSameDate(date1, date2) {
  return moment(date1).isSame(date2, 'day')
}

export function dateToday() {
  return moment().format('YYYY-MM-DD')
}

export function dateTomorrow() {
  return moment().add(1, 'd').format('YYYY-MM-DD')
}

export function minutesToTime(m) {
  if (m === undefined || m === null) {
    return null
  }
  let result = new Date(0)
  return moment(result.setHours(0, m, 0, 0)).format('hh:mm A')
}

export function dateToLocalMidnight(date) {
  let d = new Date(date)
  d.setHours(0, 0, 0, 0)
  return d
}